<template>
  <div>
    <div class="login-container">
      <div class="login-wrapper">
        <div class="container dd_login">
          <div class="row justify-content-center">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div class="card border-0 mb-0">
                <div class="card-body px-lg-5 py-lg-5">
                  <!----><!---->
                  <div class="text-center text-muted mb-4">
                    <img
                      id="profile-img"
                      src="../assets/logo.png"
                      class="img-fluid"
                      alt="Homologação"
                    />
                  </div>
                  <Form @submit="handleLogin" :validation-schema="schema">
                    <div class="form-group">
                      <div class="form-floating txt-form-label">
                        <Field
                          name="email"
                          type="email"
                          class="form-control txt-form-input"
                          placeholder="Digite seu e-mail"
                        />
                        <label for="email">Email</label>
                        <ErrorMessage name="email" class="error-feedback" />
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="form-floating txt-form-label">
                        <Field
                          name="password"
                          type="password"
                          class="form-control txt-form-input"
                          placeholder="Digite sua Senha"
                        />
                        <label for="password">Password</label>
                        <ErrorMessage name="password" class="error-feedback" />
                      </div>
                    </div>
                    <br />
                    <div class="form-group">
                      <button class="btn btn-lg btn-filtro" :disabled="loading">
                        <span
                          v-show="loading"
                          class="spinner-border spinner-border-sm"
                        ></span>
                        <span class="rf_texto_btn">Login</span>
                      </button>
                    </div>

                    <div class="form-group mt-1">
                      <div class="form-floating txt-form-label">
                        <select
                          class="form-select txt-form-input"
                          v-model="empresaSelecionada"
                          @change="redirecionar"
                        >
                          <option value="">Selecione a empresa</option>
                          <option
                            v-for="empresa in empresasLiberadas"
                            :value="empresa.id"
                            :key="empresa.id"
                          >
                            {{ empresa.nome }}
                          </option>
                        </select>
                        <label>Empresa</label>
                      </div>
                    </div>

                    <div class="form-group">
                      <div
                        v-if="message"
                        class="alert alert-danger"
                        role="alert"
                      >
                        {{ message }}
                      </div>
                    </div>
                  </Form>
                </div>
                <!----><!---->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RodapeVue />
  </div>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
//import axios from "axios";
import AuthService from "../services/auth.service";
import RodapeVue from "./menu/Rodape.vue";

export default {
  name: "Login",
  components: {
    Form,
    Field,
    ErrorMessage,
    RodapeVue
  },
  data() {
    const schema = yup.object().shape({
      email: yup.string().required("Email não pode ser vazio! "),
      password: yup.string().required("Senha não pode ser vazio!")
    });

    return {
      loading: false,
      message: "",
      schema,
      empresasLiberadas: [],
      empresaSelecionada: ""
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes("Função: ADMINISTRADOR");
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes("Função: GERENTE");
      }

      return false;
    },
    showAtendimentoBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes("Função: RECEPÇÃO");
      }

      return false;
    },
    showVendedorBoard() {
      if (this.currentUser && this.currentUser["funcoes"]) {
        return this.currentUser["funcoes"].includes(
          "Função: VENDEDOR DE VEÍCULOS"
        );
      }

      return false;
    }
  },
  created() {
    if (this.loggedIn) {
      if (this.showAdminBoard) {
        this.$router.push("/admin");
      } else if (this.showModeratorBoard) {
        this.$router.push("/desk/indexGerente");
      } else if (this.showAtendimentoBoard) {
        this.$router.push("/atendimento/dashboard");
      } else if (this.showVendedorBoard) {
        this.$router.push("/desk/index");
      } else {
        this.$router.push("/profile");
      }
    }
  },
  methods: {
    async handleLogin(user) {
      console.log("Dados do usuário logado:");
      console.log(user);
      this.loading = true;

      try {
        // Faça o login do usuário com email e senha usando a ação do Vuex
        const response = await this.$store.dispatch("auth/login", user);
        console.log(response);
        // Atualize as empresas liberadas no componente
        this.empresasLiberadas = response.empresas;

        this.loading = false;

        // Se houver empresas liberadas, não é necessário redirecionar aqui,
        // pois o usuário ainda precisa escolher uma empresa.
      } catch (error) {
        this.loading = false;
        this.message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    },

    async redirecionar() {
      try {
        // Agora, o usuário seleciona uma empresa
        const selectedCompanyId = this.empresaSelecionada;
        // Obtenha o ID do usuário logado
        const userId = this.$store.state.auth.user.id;

        // Faça a chamada para o servidor para obter o token JWT com a empresa selecionada
        const usuarioComEmpresa = await AuthService.getToken(
          selectedCompanyId,
          userId
        );
        this.$store.commit("auth/loginSuccess", usuarioComEmpresa);

        // Determine a rota apropriada com base nas funções do usuário
        if (this.showAdminBoard) {
          this.$router.push("/admin");
        } else if (this.showModeratorBoard) {
          this.$router.push("/desk/indexGerente");
        } else if (this.showAtendimentoBoard) {
          this.$router.push("/atendimento/proposta");
        } else if (this.showVendedorBoard) {
          this.$router.push("/desk/index");
        } else {
          this.$router.push("/profile");
        }
      } catch (error) {
        if (error.response.status == 400) {
          this.abrir_modal = true;
          this.msg = error.response.data.message;
        }
      }
    }
  }
};
</script>
<style scoped>
.login-container {
  display: block;
  flex-direction: column;
  min-height: 90vh;
}

.login-wrapper {
  display: block;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 20px;
  padding-top: 50px;
}

.dd_login {
  width: 100%;
  max-width: 450px;
}

/* Ajustes para tablets e celulares */
@media (max-width: 575px) {
  .login-wrapper {
    align-items: flex-start;
    padding-top: 50px;
  }

  .dd_login {
    padding: 0 15px;
  }

  /* Remove qualquer comportamento de grid/coluna */
  .row {
    display: block !important;
    margin: 0 !important;
  }

  [class*="col-"] {
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }
}
</style>
